export default "__VITE_ASSET__BRktQa08__"